export default __webpack_public_path__ + "static/media/triobanner.fe78d65c.png";